<template>
  <div>
    <GoTo
      class="mb-8"
      testId="ssoLogin-button-backLogin"
      :linkMessage="$t('authManagePeople.go_back_to_login')"
      @onClickGoTo="$emit('onGoBackClick')"
    />

    <v-text-field
      required
      outlined
      dense
      data-private
      class="body-2"
      data-testid="ssoLogin-input-email"
      type="text"
      :value="email"
      :label="`${$t('auth.register.email')}*`"
      :rules="emailRules"
      @input="$emit('onChange', $event)"
      @keyup.enter="onSubmit"
    ></v-text-field>

    <v-alert
      v-if="showSSOErrorAlert"
      colored-border
      color="red"
      dense
      border="left"
      elevation="2"
      class="text-caption"
    >
      {{ $t('authManagePeople.loginError') }}
    </v-alert>

    <Button
      data-testid="ssoLogin-button-next"
      block
      color="primary"
      class="mt-4 mb-3"
      size="large"
      :text="$t('common.button.next')"
      @click="onSubmit"
    />
  </div>
</template>

<script>
import validationHelper from '@/lib/validationHelper.js'

import GoTo from './components/GoTo.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'SSOLoginForm',
  props: {
    email: {
      type: String,
      required: false,
    },

    showSSOErrorAlert: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      isFormValid: false,
      emailRules: [
        value =>
          !!value?.trim?.() ||
          this.$t('validation.form.this_field_is_required'),
        email =>
          !this.$constants.organization.domainsBlacklist.includes(
            this.getDomain(email)
          ) || this.$t('organization.domain_is_insecure_to_add'),

        email =>
          validationHelper.isValidEmailAddress(email) ||
          this.$t('validation.user.please_enter_a_valid_email_address'),
      ],
    }
  },

  components: {
    Button,
    GoTo,
  },

  methods: {
    getDomain(email) {
      return email?.replace?.(/.*@/, '') ?? ''
    },

    onSubmit() {
      this.$emit('onSubmit', this.account)
    },
  },
}
</script>
